<template>
  <div id="confirm-deleted" class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true" style="top:23%;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" style="margin-left: 5%;opacity: 60%;" id="myModalLabel">Confirm Your Action</h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="card-body" style="padding: 10px 50px;">
        <div class="row" v-if="status == true" style="justify-content: center;">
          <h4>Are you sure want to make the payment?</h4>

        </div>
        <div class="row" v-else-if="status == false" style="justify-content: center;">
          <h4>Your payment amount is greater than amount in wallet </h4>

        </div>
        <hr>
        <div class="col-sm-12">
          <div class="form-group">
            <div  v-if="status == true" class="custom-control custom-checkbox mr-sm-2" style="padding-left:0">
              <button type="submit" class="btn btn-success mr-2 " data-dismiss="modal"
              aria-hidden="true" @click="makepayment" >Yes</button>
              <button type="button" class="btn btn-danger mr-2" data-dismiss="modal" aria-hidden="true">Cancel</button>
            </div>
             <div  v-else-if="status == false"  class="custom-control custom-checkbox mr-sm-2" style="padding-left:0">
              <button type="button" class="btn btn-info mr-2 " data-dismiss="modal"
              aria-hidden="true" @click="addwallet" >Add Wallet</button>
              <button type="button" class="btn btn-danger mr-2" data-dismiss="modal" aria-hidden="true">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'ConfirmPayment',
  components: {

  },
  props: ['status' , 'payment'],
  methods:{
    makepayment(){
       this.$store.dispatch('payment/make_user_payment',this.payment)
    },
    addwallet(){
        this.$router.push( '/mywallet')
    }
  }
}
</script>
